import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type { UpdateWidgetLinkArgs } from "../types"

export const widgetLinkMutators = {
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateWidgetLinkArgs }) => {
			await tx.mutate.widgetLinks.update(args)
		},
	),
}
